export const CouponScopeEnum = Object.freeze({
  ALL: 'ALL',
  PLAN: 'PLAN',
  ITEM_TOTAL: 'ITEM_TOTAL',
  ITEM: 'ITEM',
});

export const CouponValueTypeEnum = Object.freeze({
  PERCENT: 'PERCENT',
  FIXED: 'FIXED',
});

export const CouponTypeEnum = Object.freeze({
  DISCOUNT: 'DISCOUNT',
  ENROLLMENT: 'ENROLLMENT',
});
